// Tracking script loader utilities
// These functions dynamically load tracking scripts only after user consent
import { clearCookieEverywhere } from './cookieConsent';

const GA_SCRIPT_ID = 'js360-google-analytics';
const FB_SCRIPT_ID = 'js360-facebook-pixel';
const ADS_SCRIPT_ID = 'js360-google-ads';

/**
 * Load Google Analytics
 * @param {string} trackingId - Your Google Analytics tracking ID (e.g., 'G-XXXXXXXXXX')
 */
export function loadGoogleAnalytics(trackingId = process.env.REACT_APP_GA_TRACKING_ID) {
  if (!trackingId) {
    console.warn('Google Analytics tracking ID not configured');
    return;
  }

  if (window.gtag) {
    console.log('Google Analytics already loaded');
    return;
  }

  const script = document.createElement('script');
  script.id = GA_SCRIPT_ID;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', trackingId);

  console.log('Google Analytics loaded');
}

/**
 * Load Facebook Pixel
 * @param {string} pixelId - Your Facebook Pixel ID
 */
export function loadFacebookPixel(pixelId = process.env.REACT_APP_FB_PIXEL_ID) {
  if (!pixelId) {
    console.warn('Facebook Pixel ID not configured');
    return;
  }

  if (window.fbq) {
    console.log('Facebook Pixel already loaded');
    return;
  }

  /* eslint-disable */
  !function(f,b,e,v,n,t,s) {
    if(f.fbq) return;
    n=f.fbq=function() {
      n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments)
    };
    if(!f._fbq) f._fbq=n;
    n.push=n;
    n.loaded=!0;
    n.version='2.0';
    n.queue=[];
    t=b.createElement(e);
    t.id='js360-facebook-pixel';
    t.async=!0;
    t.src=v;
    s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)
  }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');

  console.log('Facebook Pixel loaded');
}

/**
 * Load Google Ads conversion tracking
 * @param {string} conversionId - Your Google Ads conversion ID (e.g., 'AW-XXXXXXXXXX')
 */
export function loadGoogleAds(conversionId = process.env.REACT_APP_GOOGLE_ADS_ID) {
  if (!conversionId) {
    console.warn('Google Ads conversion ID not configured');
    return;
  }

  if (window.gtag) {
    // If GA is already loaded, just add the conversion tracking
    window.gtag('config', conversionId);
    console.log('Google Ads conversion tracking added');
    return;
  }

  const script = document.createElement('script');
  script.id = ADS_SCRIPT_ID;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${conversionId}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', conversionId);

  console.log('Google Ads loaded');
}

/**
 * Load all marketing/remarketing scripts
 * Call this function when user consents to marketing cookies
 */
export function loadMarketingScripts() {
  loadFacebookPixel();
  loadGoogleAds();
  // Add other marketing scripts here as needed
}

/**
 * Check if tracking scripts are loaded
 */
export function isAnalyticsLoaded() {
  return !!window.gtag;
}

export function isMarketingLoaded() {
  return !!window.fbq;
}

export function clearTrackingScripts() {
  [GA_SCRIPT_ID, FB_SCRIPT_ID, ADS_SCRIPT_ID, 'ze-snippet'].forEach((id) => {
    document.getElementById(id)?.remove();
  });

  document.querySelectorAll(
    'script[src*="googletagmanager.com"], script[src*="connect.facebook.net"], script[src*="static.zdassets.com"], iframe[src*="zendesk"], iframe[src*="zdassets"]'
  ).forEach((element) => element.remove());

  delete window.gtag;
  delete window.fbq;
  delete window._fbq;
  delete window.zE;
  delete window.zESettings;
  delete window.openZendeskChat;
  delete window.hideZendeskWidget;
  delete window.showZendeskWidget;
  window.dataLayer = [];

  [
    '_ga',
    '_gid',
    '_gat',
    '_gcl_au',
    '_gcl_aw',
    '_fbp',
    '_fbc',
    'distinct_id',
  ].forEach(clearCookieEverywhere);

  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    if (/^(_ga_|_gcl_|_zendesk)/.test(name)) {
      clearCookieEverywhere(name);
    }
  });
}
